import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Components as DateFilterComponents } from './dateFilter.style';
import FilterCardWrapper from '../FilterCardWrapper/FilterCardWrapper';
import Switch from '../../Switch';
import InputDate from '../../InputDate';
import { differenceInCalendarDays, startOfToday, subWeeks, subDays, format } from 'date-fns';
import { formatDateFromGivenDay, formatToISOString
// formatToRelativeDate,
} from '../../../utils/helpers';
function DateFilter(_ref) {
  let {
    title,
    fromDate = '',
    toDate,
    relativeDate,
    toDays = '',
    fromDays = '',
    filterType,
    fieldData,
    expanded = false,
    onCardToggle,
    onDateSelect
  } = _ref;
  const relativeDateOptions = [{
    label: 'Range',
    value: 'range'
  }, {
    label: 'Exact',
    value: 'exact'
  }];
  const validationError = {
    fromDate: 'Enter valid From date',
    toDate: 'Enter valid To date'
  };
  const [isRelativeFilter, setIsRelativeFilter] = useState(filterType === 'RELATIVE_DATE_RANGE');
  const [rangeType, setRangeType] = useState(relativeDateOptions[0]);
  // Non Relative filter type starts here
  const [fromDateLocal, setFromDateLocal] = useState();
  const [toDateLocal, setToDateLocal] = useState();
  // Non Relative filter type ends here
  // Relative filter type starts here
  const [fromDaysLocal, setFromDaysLocal] = useState('');
  const [toDaysLocal, setToDaysLocal] = useState('');
  const [relativeDateLocal, setRelativeDateLocal] = useState('');
  const [fromDayFormatted, setFromDayFormatted] = useState(null);
  const [toDayFormatted, setToDayFormatted] = useState(null);
  // const [relativeFromInputType, setRelativeFromInputType] = useState('date');
  // const [relativeToInputType, setRelativeToInputType] = useState('date');
  // const [fromDateRelativeDiff, setFromDateRelativeDiff] = useState('');
  // const [toDateRelativeDiff, setToDateRelativeDiff] = useState('');
  // Relative filter type ends here
  useEffect(() => {
    if (filterType === 'RELATIVE_DATE_RANGE') {
      const formatFromDays = fromDays ? formatDateFromGivenDay(fromDays, startOfToday()) : '';
      const formatToDays = toDays ? formatDateFromGivenDay(toDays, startOfToday()) : '';
      setFromDaysLocal(fromDays ? fromDays : '');
      setToDaysLocal(toDays ? toDays : '');
      setRelativeDateLocal(relativeDate ? startOfToday() : '');
      formatFromDays && setFromDayFormatted(format(new Date(formatFromDays), 'yyyy-MM-dd'));
      formatToDays && setToDayFormatted(format(new Date(formatToDays), 'yyyy-MM-dd'));
      // setFromDateRelativeDiff(
      //   formatFromDays
      //     ? formatToRelativeDate(formatFromDays, startOfToday())
      //     : ''
      // );
      // formatToDays &&
      //   formatToDays &&
      //   setToDateRelativeDiff(
      //     formatToDays ? formatToRelativeDate(formatToDays, startOfToday()) : ''
      //   );
    } else {
      setFromDateLocal(fromDate ? format(new Date(fromDate), 'yyyy-MM-dd') : null);
      setToDateLocal(toDate ? format(new Date(toDate), 'yyyy-MM-dd') : null);
    }
  }, [fromDate, filterType, fromDays, relativeDate, toDays]);
  useEffect(() => {
    onSubmit();
  }, [fromDateLocal, toDateLocal, fromDayFormatted, toDayFormatted]);
  const handleRelativeSwitchChange = () => {
    setIsRelativeFilter(!isRelativeFilter);
    setFromDaysLocal('');
    setToDaysLocal('');
    setRelativeDateLocal('');
    setFromDayFormatted('');
    setToDayFormatted(null);
  };
  const handleRangeDropdown = event => {
    const index = relativeDateOptions.findIndex(item => item.value === event.target.value);
    setRangeType(relativeDateOptions[index]);
    if (event.target.value === 'exact') {
      setToDateLocal(null);
      setToDayFormatted(null);
    }
  };
  const handleDateChange = (date, type) => {
    if (type === 'fromDateNonRelative') {
      setFromDateLocal(date);
      setToDateLocal(null);
      if ((rangeType === null || rangeType === void 0 ? void 0 : rangeType.value) === 'exact') {
        setToDateLocal(date);
      } else {
        setToDateLocal(null);
      }
    } else if (type === 'toDateNonRelative') {
      setToDateLocal(date);
    } else if (type === 'fromDateRelative') {
      setFromDayFormatted(date);
      setRelativeDateLocal(startOfToday());
      const fromDaysLocal = differenceInCalendarDays(new Date(date), startOfToday());
      setFromDaysLocal(fromDaysLocal);
      // setFromDateRelativeDiff(formatToRelativeDate(new Date(), startOfToday()));
    } else if (type === 'toDateRelative') {
      setToDayFormatted(date);
      setRelativeDateLocal(startOfToday());
      const toDaysLocal = differenceInCalendarDays(new Date(date), startOfToday());
      setToDaysLocal(toDaysLocal);
      // setToDateRelativeDiff(
      //   formatToRelativeDate(new Date(date), startOfToday())
      // );
    }
  };
  const onPresetDateChange = presetType => {
    const today = startOfToday();
    if (presetType === 'Today') {
      if (isRelativeFilter) {
        setRelativeDateLocal(today);
        setFromDaysLocal(differenceInCalendarDays(today, today));
        setToDaysLocal(differenceInCalendarDays(today, today));
        setFromDayFormatted(format(today, 'yyyy-MM-dd'));
        setToDayFormatted(format(today, 'yyyy-MM-dd'));
        // setRelativeToInputType('text');
        // setRelativeFromInputType('text');
        // setFromDateRelativeDiff(formatToRelativeDate(today, startOfToday()));
        // setToDateRelativeDiff(formatToRelativeDate(today, startOfToday()));
      } else {
        if (today) {
          setFromDateLocal(format(today, 'yyyy-MM-dd'));
          setToDateLocal(format(today, 'yyyy-MM-dd'));
        }
      }
    } else if (presetType === 'Last 7 days') {
      const fromDate = subWeeks(today, 1);
      if (isRelativeFilter) {
        setRelativeDateLocal(today);
        setFromDaysLocal(differenceInCalendarDays(fromDate, today));
        setFromDayFormatted(format(fromDate, 'yyyy-MM-dd'));
        setToDayFormatted(format(today, 'yyyy-MM-dd'));
        setToDaysLocal(differenceInCalendarDays(today, today));
        // setRelativeToInputType('text');
        // setRelativeFromInputType('text');
        // setFromDateRelativeDiff(formatToRelativeDate(fromDate, startOfToday()));
        // setToDateRelativeDiff(formatToRelativeDate(today, startOfToday()));
      } else {
        setFromDateLocal(format(fromDate, 'yyyy-MM-dd'));
        setToDateLocal(format(today, 'yyyy-MM-dd'));
      }
    } else if (presetType === 'Last 30 days') {
      const fromDate = subDays(today, 30);
      if (isRelativeFilter) {
        setRelativeDateLocal(today);
        setFromDaysLocal(differenceInCalendarDays(fromDate, today));
        setFromDayFormatted(format(fromDate, 'yyyy-MM-dd'));
        setToDayFormatted(format(today, 'yyyy-MM-dd'));
        setToDaysLocal(differenceInCalendarDays(today, today));
        // setRelativeToInputType('text');
        // setRelativeFromInputType('text');
        // setFromDateRelativeDiff(formatToRelativeDate(fromDate, startOfToday()));
        // setToDateRelativeDiff(formatToRelativeDate(today, startOfToday()));
      } else {
        setFromDateLocal(format(fromDate, 'yyyy-MM-dd'));
        setToDateLocal(format(today, 'yyyy-MM-dd'));
      }
    }
  };
  const onSubmit = () => {
    onDateSelect(fromDateLocal || fromDayFormatted ? [{
      from: !isRelativeFilter && fromDateLocal ? formatToISOString(new Date(fromDateLocal)) : null,
      to: !isRelativeFilter && toDateLocal ? formatToISOString(new Date(toDateLocal)) : null,
      from_days: isRelativeFilter ? fromDaysLocal : null,
      to_days: isRelativeFilter ? toDaysLocal : null,
      relative_date: relativeDateLocal ? formatToISOString(relativeDateLocal) : null,
      type: relativeDateLocal ? 'RELATIVE_DATE_RANGE' : 'RANGE',
      inclusive_from: !!(fromDateLocal || fromDayFormatted),
      inclusive_to: !!(toDateLocal || toDayFormatted),
      filterName: title,
      property_id: fieldData.fieldName
    }] : [], title);
  };
  return _jsx(DateFilterComponents.Wrapper, {
    children: _jsx(FilterCardWrapper, {
      title: title,
      expanded: expanded,
      body: _jsxs("div", {
        children: [_jsxs(DateFilterComponents.Head, {
          children: [_jsx(DateFilterComponents.RadioArea, {
            children: _jsx(Switch, {
              id: (title || '').split(' ').join('').toLowerCase(),
              type: "standard",
              label: "Relative Date",
              checked: isRelativeFilter,
              onChange: handleRelativeSwitchChange
            })
          }), _jsx(DateFilterComponents.DateFilterSelect, {
            id: "date-filter-type",
            name: "date-filter-type",
            options: relativeDateOptions,
            value: [rangeType],
            variant: "default",
            onChange: e => handleRangeDropdown(e)
          })]
        }), isRelativeFilter ? _jsxs(DateFilterComponents.DateRangeWrapper, {
          children: [_jsx(DateFilterComponents.DateInputWrapper, {
            children: _jsx(InputDate, {
              id: "from-relative-date",
              label: "From Date",
              value: fromDayFormatted,
              errorMessage: validationError.fromDate,
              onChange: date => {
                // setRelativeFromInputType('text');
                handleDateChange(date, 'fromDateRelative');
              }
            })
          }), rangeType.value === 'range' && _jsx(DateFilterComponents.DateInputWrapper, {
            children: _jsx(InputDate, {
              id: "to-relative-date",
              label: "To Date",
              value: toDayFormatted,
              errorMessage: validationError.fromDate,
              onChange: date => {
                // setRelativeToInputType('text');
                handleDateChange(date, 'toDateRelative');
              }
            })
          })]
        }) : _jsxs(DateFilterComponents.DateRangeWrapper, {
          children: [_jsx(InputDate, {
            id: "from-date-filter",
            label: "From Date",
            value: fromDateLocal,
            errorMessage: validationError.fromDate,
            onChange: date => handleDateChange(date, 'fromDateNonRelative')
          }), rangeType.value === 'range' && _jsx(InputDate, {
            id: "to-date-filter",
            name: "to-date-filter",
            label: "To Date",
            value: toDateLocal,
            errorMessage: "validationError.toDate",
            disabled: !fromDateLocal,
            min: (fromDateLocal === null || fromDateLocal === void 0 ? void 0 : fromDateLocal.toString()) || new Date().toString(),
            onChange: date => handleDateChange(date, 'toDateNonRelative')
          })]
        }), _jsx(DateFilterComponents.DateFilterButton, {
          variant: "outlined",
          label: "Today",
          onClick: () => onPresetDateChange('Today')
        }), rangeType.value === 'range' && _jsx(DateFilterComponents.DateFilterButton, {
          variant: "outlined",
          label: "Last 7 days",
          onClick: () => onPresetDateChange('Last 7 days')
        }), rangeType.value === 'range' && _jsx(DateFilterComponents.DateFilterButton, {
          variant: "outlined",
          label: "Last 30 days",
          onClick: () => onPresetDateChange('Last 30 days')
        })]
      }),
      onCardToggle: onCardToggle
    })
  });
}
export default DateFilter;